/**
 * @module api-web:warehouseStatus
 */
import service from '@/service'

/**
 * 库存状态 表查询
 * @param {{keywords:string,limit:number,page:number,sort:string,documentStatus:number}} params
 */
export function getList(params) {
  return service['api-web']({
    url: '/data/basic/warehouseStatus/getList',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 库存状态 详情
 */
export function info(id) {
  return service['api-web']({
    url: '/data/basic/warehouseStatus/info',
    method: 'get',
    params: { id }
  })
}

/**
 * 待办详情 (无需权限)
 */
export function todoInfo(id) {
  return service['api-web']({
    url: '/public/activiti/warehouseStatus/info',
    method: 'get',
    params: { id }
  })
}
/**
 * 新增
 */
export function save(data) {
  return service['api-web']({
    url: '/data/basic/warehouseStatus/save',
    method: 'post',
    data
  })
}

/**
 * 库存状态 修改
 */
export function update(data) {
  return service['api-web']({
    url: '/data/basic/warehouseStatus/update',
    method: 'post',
    data
  })
}
/**
 * @param {object}
 * @returns 审核驳回
 */
export function reject(data) {
  return service['api-web']({
    url: '/public/activiti/warehouseStatus/reject',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @param {(string|number)} ids
 * @description 结束流程（结束审核流）
 */
export function withdraw(ids) {
  return service['api-web']({
    url: '/data/basic/warehouseStatus/withdraw',
    method: 'post',
    data: { ids },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 提交
 * @param {{ids:string}} ids
 */
export function submit(ids) {
  return service['api-web']({
    url: '/data/basic/warehouseStatus/submit',
    method: 'post',
    data: { ids },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
/**
 * 启用禁用
 * @param {(string|number)} id - id
 * @param {(0|1)} status - 0:禁用 1:启用
 */
export function enableDisable(data) {
  return service['api-web']({
    url: '/data/basic/warehouseStatus/updateDisableStatus',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
